module.exports = __webpack_public_path__ + "static/media/violin.0f77ecec.svg";